.row {
  &[data-selected='true'] {
    border: 1px solid var(--color-primary-crayola, #367bff);
    background: rgba(54, 123, 255, 0.3);

    & td {
      border-top: 1px solid var(--color-primary-crayola, #367bff);
      border-bottom: 1px solid var(--color-primary-crayola, #367bff);

      &:first-child {
        border-left: 1px solid var(--color-primary-crayola, #367bff);
      }

      &:last-child {
        border-right: 1px solid var(--color-primary-crayola, #367bff);
      }
    }
  }
}

.cell-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.select-box {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

/**
 * Reveal the check box on hover only where a pointer can actually hover — on a touch screen
 * there is no hover state to reveal it with, so it stays visible. A selected row keeps its box
 * on screen so the selection is still legible once the pointer moves away, and `:focus-within`
 * covers reaching it by keyboard.
 */
@media (hover: hover) {
  .select-box {
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
  }

  .row:hover .select-box,
  .row[data-selected='true'] .select-box,
  .select-box:focus-within {
    opacity: 1;
  }
}
